import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { PIX_TRANSFERS_ROUTE_PATHS } from './config';

export const PIX_TRANSFERS_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-pix-transfers',
    path: PIX_TRANSFERS_ROUTE_PATHS.pixTransfers,
    component: lazy(() => import('./pages/pix-transfers-page')),
    layout: 'default',
    permissions: { scopes: ['movements-pix-transfers'] },
    menu: {
      title: 'Pix Transfers',
    },
  },
];
